export default {
  "content": "<path d=\"M17 0H3C1.34 0 0 1.34 0 3v8c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm1 11c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V6h16v5zM2 4V3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v1H2z\" fill=\"#000\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "20",
    "height": "14",
    "viewBox": "0 0 20 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};